module.exports = __webpack_public_path__ + "img/logo-web.aa0d3ae4.png";